var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-disc ml-2"},_vm._l((_vm.details),function(packing){return _c('li',{key:packing.packing_detail_id},[_vm._v(_vm._s(packing.packing_material)+" : "+_vm._s(packing.packing_layer))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }